import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, AppBar, Toolbar, Tooltip, Icon } from '@material-ui/core';
import HyperbloxLogo from '../../images/hyperblox-logo.png';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { getLoggedUsername, getLoggedInUserFirstName, getLoggedInUserLastName } from "../../store/auth/selectors"
import { useDispatch } from "react-redux";
import IdleTimer from "../../services/timer";
import Auth from "../../store/auth/actions";
import config from "../../config";
import { UserDetailsDropDown } from '../../components/molecules/user/UserDropDown';
import { useSelector } from 'react-redux'
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import { setIdeBuildVersion, triggerTour } from '../../store/global/actions';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { logInfo } from '../../utils/logger';

const dayjs = require("dayjs");

const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
  },
  AppBar: {
    zIndex: theme.zIndex.drawer + 2,
    backgroundColor: "#fff",
    backgroundSize: "cover",
    color: "#2c3b4a",
    fontFamily: "OpenSans",
    fontWeight: 600,
    fontSize: "14px",
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: {
    width: 34,
    marginRight: 17,
    marginLeft: -7
  },
  menuDrawer: {
    width: "100px",
    flexShrink: 0,
  },
  menuDrawerPaper: {
    width: "100px",
    backgroundColor: '#48566a',

  },
  btn: {
    textTransform: "none",
    color: "#2c3b4a",
  },
  documentation: {
    fontFamily: "Roboto, Helvetica"
  }
}));

export default function DashboardTopBar() {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const {pathname} = useLocation()

  const handleManualTour = () => {
    let tour = 'dashboard';
    console.log({pathname});
    
    if(pathname.includes('configuration')){
      tour = 'configurations'
    }else if(pathname.includes('backup-and-restore')){
      tour = 'backupModal'
    }else if(pathname === "/" || pathname === ""){
      tour = 'dashboard'
    }
    dispatch(triggerTour({currentTour: tour, initStart: true}))
  }

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.AppBar}>
        <Toolbar className={classes.toolbar}>
          <img src={HyperbloxLogo} alt="Hyperblox logo" className={classes.logo} />
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <a title="Open Hyperblox Builder documentation" className={classes.documentation} href='/docs/getting-started/' target="_blank">Documentation</a>
          <Tooltip title='Show Tour'>
            <Icon onClick={handleManualTour} style={{height: '2rem', width: 'auto', display: 'flex',justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
              <ContactSupportIcon style={{fontSize: '2rem'}}/>
            </Icon>
          </Tooltip>
            {matches && <BuildVersion />}
            {/* <UserDetails />
            <Logout title="Signout from IDE" /> */}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
const Logout = ({ title }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const timer = new IdleTimer({
      timeout: 10,
      onTimeout: () => {
        dispatch(Auth.authCheck(true));
      },
      onExpired: () => {
        dispatch(Auth.authCheck(true));
      },
    });

    return () => {
      timer.cleanUp();
    };
  }, []);

  const logout = (va) => dispatch(Auth.logout());
  return (
    null
  );
};

const BuildVersion = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [version, setVersion] = useState(null);

  React.useEffect(() => {
    const URL = config.apiUrl + "get-build-history";
    fetch(URL)
      .then((response) => response.json())
      .then((response) => {
        setVersion(response.data);
        dispatch(setIdeBuildVersion({build: response?.data?.build?.trim(), date: response?.data?.date}))
      });
  }, []);
  
  return (
    <Button
      className={classes.btn}
      disabled={!Boolean(version)}
      disableFocusRipple
      disableTouchRipple
      disableRipple
      disableElevation
      startIcon={`Builder version: ${version && version.build}` || ""}
    >
      {version && version.date ? dayjs(version && version.date).format("YYYY-MM-DD HH:mm:ss") : ""}
    </Button>
  );
};

const UserDetails = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const loggedInUsername = useSelector(getLoggedUsername)
  const loggedInFirstName = useSelector(getLoggedInUserFirstName)
  const loggedInLastName = useSelector(getLoggedInUserLastName)
  let loggedFirstName = "";

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openChangePassword, setOpenChangePassword] = React.useState(false);
  const open = Boolean(anchorEl);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  if (loggedInFirstName !== undefined && loggedInFirstName !== "") {
    loggedFirstName = loggedInFirstName.charAt(0).toUpperCase() + loggedInFirstName.slice(1);
  }
  else {
    loggedFirstName = "";
  }

  return (
    <>
      <Button id="loggedInUserName" className={classes.btn} aria-controls="simple-popover" aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick} endIcon={<img src={`${process.env.PUBLIC_URL}/ide_icons/arrowDropdown.svg`} />}>{loggedFirstName}</Button>

      {anchorEl && <UserDetailsDropDown anchorEl={anchorEl} handleClose={handleClose} />}


    </>
  )
}